{
    "(save {highestYearlyDiscount}%)": "可省{highestYearlyDiscount}%",
    "{amount} days free": "{amount}天免费",
    "{amount} off": "减免{amount}",
    "{amount} off for first {number} months.": "前{number}月减免{amount}",
    "{amount} off for first {period}.": "首{period}减免{amount}",
    "{amount} off forever.": "永久减免{amount}",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "{buyerName} 赠送了您 {siteTitle} 的 <strong>{duration} 个月</strong> {tierName} 会员资格",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "{buyerName} 赠送了您 {siteTitle} 的 <strong>{duration} 年</strong> {tierName} 会员资格",
    "{discount}% discount": "{discount}% 折扣",
    "{duration} membership": "{duration} 会员资格",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail}将不会再收到{newsletterName}的新闻信。",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail}将不会再收到评论回复提醒邮件。",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail}将不会再收到本新闻信。",
    "{memberEmail} will no longer receive updates & announcements.": "{memberEmail} 将不再收到更新与公告。",
    "{months} month": "{months} 个月",
    "{months} months": "{months} 个月",
    "{months} months free": "{months} 个月免费",
    "{tierName} membership": "{tierName} 会员资格",
    "{trialDays} days free": "{trialDays} 天免费试用",
    "{years} years": "{years} 年",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "1 个月",
    "1 month free": "1 个月免费",
    "1 year": "1 年",
    "A gift, just for you": "专属于您的礼物",
    "Access your RSS feeds": "访问您的 RSS 源",
    "Account": "账户",
    "Account details updated successfully": "账户信息更新成功",
    "Account settings": "账户设置",
    "Add a personal note": "添加个人备注",
    "Add a short note to go with your gift": "添加附言随礼物一同发送",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "免费试用结束后，您将被收取所选方案的标准价格。在此之前，您可以随时取消。",
    "Already a member?": "已经是会员了？",
    "An error occurred": "发生错误",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "遇到意外错误。请重试，若持续出现请<a>联系支持服务</a>。",
    "Back": "返回",
    "Back to Log in": "返回登录",
    "Before you go": "在您离开之前",
    "Billing info & receipts": "账单信息与收据",
    "Black Friday": "黑五促销",
    "Bluesky": "",
    "Buy": "购买",
    "Buying for someone else?": "要送给其他人吗？",
    "Cancel anytime.": "随时取消",
    "Cancel subscription": "取消订阅",
    "Canceled": "已取消",
    "Cancellation reason": "取消原因",
    "Change": "更改",
    "Change plan": "更改订阅方案",
    "Check spam & promotions folders": "检查垃圾邮件与促销邮件目录",
    "Check with your mail provider": "与您的邮件服务商确认",
    "Check your inbox to verify email update": "请检查您的收件箱以验证电子邮件更新",
    "Choose": "选择",
    "Choose a date from today onwards": "请选择今天或之后的日期",
    "Choose a date within the next year": "请选择未来一年内的日期",
    "Choose a delivery date": "选择送达日期",
    "Choose a different plan": "选择其他订阅方案",
    "Choose a plan": "选择一个订阅方案",
    "Choose a tier": "选择方案",
    "Choose your newsletters": "选择您的新闻信",
    "Click here to retry": "请点此处重试",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "请点击收件箱中的确认链接以完成会员兑换。如果 3 分钟内未收到，请检查您的垃圾邮件文件夹。",
    "Close": "关闭",
    "Code": "验证码",
    "Comment preferences updated.": "评论偏好设置已更新",
    "Comments": "评论",
    "Complimentary": "免费",
    "Confirm": "确认",
    "Confirm cancellation": "确认取消",
    "Confirm subscription": "确认订阅",
    "Contact support": "联系支持服务",
    "Continue": "继续",
    "Continue subscription": "继续订阅",
    "Continue to delivery details": "继续填写送达信息",
    "Continue to payment": "继续进行支付",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "您可以随时转换为付费订阅。您剩余的赠送时长将作为免费试用期累加。",
    "Copied": "已复制",
    "Copy": "复制",
    "Copy link": "复制链接",
    "Could not create Stripe billing portal session": "无法创建 Stripe 账单门户会话",
    "Could not create Stripe checkout session": "无法创建 Stripe 结账会话",
    "Could not sign in. Login link expired.": "无法登录。登录链接已过期。",
    "Could not update email! Invalid link.": "无法更新电子邮件！链接无效。",
    "Create a new contact": "创建新联系",
    "Current plan": "当前订阅",
    "Delete account": "删除账户",
    "Delivery date": "送达日期",
    "Delivery method": "送达方式",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "操作有误？可以在<button>这里</button>修改您的偏好设置。",
    "Don't have an account?": "还没有账户吗？",
    "Edit": "编辑",
    "Email": "电子邮件",
    "Email confirmation link expired.": "电子邮件确认链接已过期。",
    "Email it to them": "通过电子邮件发送给对方",
    "Email newsletter": "新闻信",
    "Email newsletter settings updated": "新闻信设置已更新",
    "Email preferences": "电子邮件偏好设置",
    "Email preferences updated.": "电子邮件偏好已更新",
    "Emails": "电子邮件列表",
    "Emails disabled": "电子邮件列表已禁用",
    "Ends {offerEndDate}": "于{offerEndDate}结束",
    "Enjoy {amountOff} off forever.": "永久享受 {amountOff} 减免。",
    "Enjoy {months} free months on us.": "免费赠送您 {months} 个月试用。",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "免费赠送您 {months} 个月试用。在 {newBillingDate} 之前不会向您收费。",
    "Enjoy a free month on us.": "免费赠送您 1 个月试用。",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "免费赠送您 1 个月试用。在 {newBillingDate} 之前不会向您收费。",
    "Enter code above": "在上方输入验证码",
    "Enter the recipient's email address": "输入收件人的电子邮箱地址",
    "Enter your email address": "输入您的电子邮箱地址",
    "Enter your name": "输入您的姓名",
    "Error": "错误",
    "Expires {expiryDate}": "于{expiryDate}过期",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "取消订阅失败，请重试",
    "Failed to log in, please try again": "登录失败，请重试",
    "Failed to log out, please try again": "登出失败，请重试",
    "Failed to open billing portal, please try again": "打开账单门户失败，请重试",
    "Failed to process checkout, please try again": "结账失败，请重试",
    "Failed to send magic link email": "发送登录链接邮件失败",
    "Failed to send verification email": "发送验证邮件失败",
    "Failed to sign up, please try again": "注册失败，请重试",
    "Failed to update account data": "更新账户数据失败",
    "Failed to update account details": "更新账户信息失败",
    "Failed to update billing information, please try again": "更新账单信息失败，请重试",
    "Failed to update newsletter settings": "更新新闻信设置失败",
    "Failed to update subscription, please try again": "更新订阅失败，请重试",
    "Failed to verify code, please try again": "验证码验证失败，请重试",
    "For a friend or colleague": "送给朋友或同事",
    "Forever": "永久",
    "Free Trial – Ends {trialEnd}": "免费试用 - {trialEnd}结束",
    "From": "发件人",
    "Get help": "获取帮助",
    "Get in touch for help": "联系我们获取帮助",
    "Get notified when someone replies to your comment": "当有人回复您的评论时收到通知。",
    "Gift a membership": "赠送会员资格",
    "Gift could not be redeemed": "无法兑换赠送的会员",
    "Gift details": "礼物详情",
    "Gift duration": "礼物期限",
    "Gift link copied to clipboard": "礼物链接已复制到剪贴板",
    "Gift membership": "赠送会员资格",
    "Gift redeemed! You're all set.": "礼物兑换成功！您已准备就绪。",
    "Gift subscription": "赠送订阅",
    "Gift subscriptions are not available right now.": "目前暂不提供赠送订阅服务。",
    "Gift value": "礼物价值",
    "Give feedback on this post": "对这篇文章提供建议",
    "Help! I'm not receiving emails": "求助！我没有收到电子邮件",
    "Here are a few other sites you may enjoy.": "以下是您或许会感兴趣的其他网站。",
    "Hi {recipientName},": "{recipientName} 您好，",
    "Hide details": "隐藏详情",
    "How would you like to share this gift?": "您想如何分享这份礼物？",
    "I'll share it myself": "我会自行分享",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "如果某份新闻信被标记为垃圾邮件，系统将自动禁用该地址的邮件接收功能，确保您不再收到任何不需要的消息。",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "如果误标记为垃圾邮件，或者您希望再次开启邮件接收，您可以通过点击上一页的按钮重新订阅。",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "如果现在取消订阅，您仍可在 {periodEnd} 之前访问内容。",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "如果您使用公司或者政府邮件账户，请联系相应IT部门以允许从{senderEmail}接收邮件。",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "登录链接已经发送到您的收件箱。如果在3分钟内还没有收到，请务必检查您的垃圾邮件文件夹。",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "邮件已发送至{submittedEmailOrInbox}。请点击邮件中的链接或在下方输入验证码。",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "如果您希望重新开始接收邮件，接下来最好先检查存档的电子邮件地址，然后在之前的页面点击重新订阅。",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "如果没有收到订阅了的新闻信，请检查以下事项。",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "如果您已经完成全部检查项目却依旧没有收到邮件，您可以联系{supportAddress}获取支持。",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "当尝试发送新闻信时遇到永久性失败时，将为该账户禁用电子邮件。",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "在您的电子邮件客户端将 {senderEmail} 加入联系人列表。这将向您的邮件供应商表明来自该地址的邮件是可信的。",
    "Invalid email address": "无效的电子邮件地址",
    "Invalid verification code": "无效的验证码",
    "Jamie Larson": "阿宇",
    "jamie@example.com": "ayu@example.com",
    "Less like this": "减少此类内容",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "确保邮件没有被意外标记为垃圾或者促销邮件。如果是，点击“非垃圾邮件”或者“移动到收件箱”。",
    "Manage": "管理",
    "Maybe later": "之后再说",
    "Membership details": "会员详情",
    "Memberships from this email domain are currently restricted.": "来自此电子邮件域名的会员申请目前受限。",
    "Memberships unavailable, contact the owner for access.": "会员资格不可用，请联系网站所有者获取访问权限。",
    "month": "月",
    "Monthly": "月付",
    "More like this": "更多类似内容",
    "More options": "更多选项",
    "Name": "姓名",
    "Need more help? Contact support": "需要更多帮助？联系支持服务",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "您账户的新闻信被禁用的可能原因有两个：先前的电子邮件被标记为垃圾邮件，或者发送邮件遇到永久错误 (bounce)",
    "No member exists with this e-mail address.": "没有会员使用此电子邮箱地址。",
    "No thanks, I want to cancel": "不用了，我想取消",
    "Not ready to share? We've also emailed a copy to your inbox.": "还没准备好分享？我们也向您的收件箱发送了一份副本。",
    "Not receiving emails?": "没有收到电子邮件？",
    "Now": "立即",
    "Now check your email!": "现在请检查您的电子邮件！",
    "Occasional updates from {siteTitle}": "来自 {siteTitle} 的不定期更新",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "重新订阅后，如果收件箱中仍然没有看到邮件，请检查垃圾邮件文件夹。一些邮件服务商会保留以往的垃圾邮件投诉记录，并继续对邮件进行标记。如果出现这种情况，请将最新的邮件通讯标记为“非垃圾邮件”，并移回主收件箱。",
    "Open AOL Mail": "打开 AOL Mail",
    "Open email": "打开电子邮件",
    "Open Feedbin": "打开 Feedbin",
    "Open Gmail": "打开 Gmail",
    "Open Hey": "打开 Hey",
    "Open iCloud Mail": "打开 iCloud Mail",
    "Open Mail.ru": "打开 Mail.ru",
    "Open Outlook": "打开 Outlook",
    "Open Proton Mail": "打开 Proton Mail",
    "Open Yahoo Mail": "打开 Yahoo Mail",
    "Optional message": "自定义消息（可选）",
    "Permanent failure (bounce)": "永久错误 (bounce)",
    "Phone number": "电话号码",
    "Plan": "订阅方案",
    "Plan checkout was cancelled.": "订阅付款已取消。",
    "Plan upgrade was cancelled.": "订阅升级已取消。",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "请联系 {supportAddress} 调整您的免费订阅。",
    "Please enter {fieldName}": "请输入{fieldName}",
    "Please fill in required fields": "请填写必须项目",
    "Podcasts": "播客",
    "Re-enable emails": "重新启用电子邮件",
    "Recipient's email": "收件人的电子邮箱",
    "Recipient's name": "收件人的姓名",
    "Recommendations": "推荐",
    "Redeem your gift": "兑换您的礼物",
    "Redeeming...": "正在兑换...",
    "Renews at {price}.": "以{price}的价格续费。",
    "Resume subscription": "恢复订阅",
    "Retry": "重试",
    "Save": "保存",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "在接下来的{durationInMonths}个账单周期中，每期可折抵{amountOff}。之后为每{cadence} {currency}{originalPrice}。",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "下期账单周期可折抵{amountOff}。之后为每{cadence} {currency}{originalPrice}。",
    "Send the link below to share it with whoever you'd like.": "发送下方链接，即可分享给您想分享的任何人。",
    "Sending login link...": "正在发送登录链接...",
    "Sending...": "发送中...",
    "Share": "分享",
    "Share a full membership to {siteTitle} with a friend or colleague": "与朋友或同事分享 {siteTitle} 的完整会员资格",
    "Share it yourself": "自行分享",
    "Show all": "显示全部",
    "Sign in": "登录",
    "Sign out": "退出",
    "Sign up": "注册",
    "Signup error: Invalid link": "注册错误：链接无效",
    "Signups from this email domain are currently restricted.": "来自此电子邮件域名的新会员注册目前受限。",
    "Something went wrong, please try again later.": "出了点问题，请稍后再试。",
    "Sorry, no paid plans are available.": "抱歉，目前没有可用的付费方案。",
    "Sorry, no recommendations are available right now.": "抱歉，目前暂无推荐。",
    "Sorry, that didn’t work.": "抱歉，该操作无法完成。",
    "Spam complaints": "垃圾邮件",
    "Start {amount}-day free trial": "开始 {amount}-天免费试用",
    "Starting {startDate}": "从{startDate}开始",
    "Starting today": "从今天开始",
    "Submit feedback": "提交建议",
    "Subscribe": "订阅",
    "Subscribed": "已订阅",
    "Subscription plan updated successfully": "订阅方案更新成功",
    "Success": "成功",
    "Success! Check your email for magic link to sign-in.": "成功！检查您的电子邮箱以获取登录链接。",
    "Success! Your account is fully activated, you now have access to all content.": "成功！您的账户已经完全激活，您现在可以访问全部内容了。",
    "Success! Your email is updated.": "成功！您的电子邮件已更新。",
    "Successfully unsubscribed": "成功取消订阅",
    "Taylor Reid": "阿宇",
    "taylor@example.com": "ayu@example.com",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "感谢您的订阅。在开始阅读之前，以下是您可能会喜欢的一些其他网站。",
    "Thank you for your support": "感谢您的支持",
    "Thank you for your support!": "感谢您的支持！",
    "Thanks for the feedback!": "感谢您的建议！",
    "That didn't go to plan": "似乎出错了",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "您的电子邮件地址是 {memberEmail} - 如果该邮箱不正确，您可以在<button>帐户设置区域</button>中更新它。",
    "There was a problem submitting your feedback. Please try again a little later.": "提交您的反馈时遇到错误。请稍后重试。",
    "There was an error cancelling your subscription, please try again.": "取消订阅时发生错误，请重试。",
    "There was an error continuing your subscription, please try again.": "续订过程中出现错误，请重试。",
    "There was an error processing your payment. Please try again.": "您的付款处理失败，请重试。",
    "There was an error sending the email, please try again": "发送电子邮件时出现错误，请重试。",
    "This gift can only be redeemed once and expires on {expiryDate}.": "此礼物只能兑换一次，并将于 {expiryDate} 过期。",
    "This gift has already been consumed.": "该礼物已被使用。",
    "This gift has already been redeemed.": "该礼物已被兑换。",
    "This gift has been refunded.": "该礼物已退款。",
    "This gift has expired.": "该礼物已过期。",
    "This gift link is invalid.": "此礼物链接无效。",
    "This site is invite-only, contact the owner for access.": "此网站仅限受邀访问，请联系网站所有者以获取权限。",
    "This site is not accepting donations at the moment.": "本网站目前不接受捐赠。",
    "This site is not accepting payments at the moment.": "本网站目前暂不接受付款。",
    "This site only accepts paid members.": "本网站仅允许付费会员。",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "方案",
    "To": "收件人",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "要完成注册，请点击您收件箱中的确认链接。如果在3分钟内没有收到，请检查一下您的垃圾邮件文件夹！",
    "To continue to stay up to date, subscribe to {publication} below.": "如需持续获取最新资讯，请在下方订阅{publication}",
    "Too many attempts try again in {number} days.": "尝试次数过多，请在{number}天后重试。",
    "Too many attempts try again in {number} hours.": "尝试次数过多，请在{number}小时后重试。",
    "Too many attempts try again in {number} minutes.": "尝试次数过多，请在{number}分钟后重试。",
    "Too many different sign-in attempts, try again in {number} days": "登录尝试次数过多，请在{number}天后重试",
    "Too many different sign-in attempts, try again in {number} hours": "登录尝试次数过多，请在{number}小时后重试",
    "Too many different sign-in attempts, try again in {number} minutes": "登录尝试次数过多，请在{number}分钟后重试",
    "Too many sign-up attempts, try again later": "注册尝试次数过多，请稍后重试",
    "Try free for {amount} days, then {originalPrice}.": "{amount}天免费试用，之后为{originalPrice}定价。",
    "Unable to initiate checkout session": "无法启动结账会话",
    "Unlock access to all newsletters by becoming a paid subscriber.": "成为付费订阅用户以解锁全部新闻信。",
    "Unsubscribe from all emails": "取消接收所有邮件",
    "Unsubscribed": "已取消订阅",
    "Unsubscribed from all emails.": "已取消接收所有邮件。",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "取消新闻信订阅不会取消您对 {title} 的付费订阅。",
    "Update": "更新",
    "Update your preferences": "更新您的偏好设置",
    "Updates & announcements": "更新与公告",
    "Verification link sent, check your inbox": "验证链接已发送，请检查您的收件箱",
    "Verify your email address is correct": "请确认您的邮箱地址是否正确",
    "Verifying...": "正在验证...",
    "View plans": "查阅订阅方案",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "我们无法取消您的订阅，因为找不到该电子邮件地址。请联系网站所有者。",
    "We'd hate to see you leave. How about a special offer to stay?": "我们很遗憾看到您离开。给您提供一个专属优惠，考虑留下来如何？",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "我们将于 {deliveryDate} 通过电子邮件发送给收件人，同时也会发送一份副本到您的收件箱。",
    "We'll email it to the recipient. A copy will be in your inbox too.": "我们将通过电子邮件发送给收件人，同时也会发送一份副本到您的收件箱。",
    "Welcome back, {name}!": "欢迎回来，{name}！",
    "Welcome back!": "欢迎回来！",
    "Welcome to {siteTitle}": "欢迎来到 {siteTitle}",
    "What's included": "包含内容",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "收件箱无法接收邮件时称为“反弹”。大多数时候这是临时的。但是某些情况下，无效或者不存在的邮件地址反弹的邮件会被认定为永久错误。",
    "Why has my email been disabled?": "为什么我的邮件功能被禁用了？",
    "X (Twitter)": "",
    "year": "年",
    "Yearly": "年付",
    "You already have an active subscription.": "您已经拥有一个处于生效状态的订阅。",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "您当前为免费用户，升级为付费订阅以获取全部内容。",
    "You have been successfully resubscribed": "您已成功重新订阅",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "您现在已获得 {tierName} 的访问权限，有效期至 {expiryDate}。尽情享受吧！",
    "You're currently not receiving emails": "您当前不会收到邮件。",
    "You're not receiving emails": "您将不会收到邮件。",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "您收不到邮件是因为您可能将最近的某个消息标记为垃圾邮件，或者无法将消息发送到您提供的邮件地址。",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "您收到了一份 <strong>{duration} 个月</strong> {tierName} 会员资格礼物",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "您收到了一份 {siteTitle} 的 <strong>{duration} 个月</strong> {tierName} 会员资格礼物",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "您收到了一份 <strong>{duration} 年</strong> {tierName} 会员资格礼物",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "您收到了一份 {siteTitle} 的 <strong>{duration} 年</strong> {tierName} 会员资格礼物",
    "You've successfully signed in.": "您已成功登录。",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "您已成功订阅 <strong>{siteTitle}</strong>",
    "Your account": "您的账户",
    "Your email": "您的电子邮件",
    "Your email has failed to resubscribe, please try again": "您的邮箱未能成功重新订阅，请重试。",
    "Your gift is on its way": "您的礼物已在路上",
    "Your gift is ready": "您的礼物已准备就绪",
    "Your gift is scheduled": "您的礼物已安排定时发送",
    "Your gift subscription will expire on {expiryDate}": "您的赠送订阅将于 {expiryDate} 到期",
    "your inbox": "您的收件箱",
    "Your input helps shape what gets published.": "您的建议将使我们变得更好。",
    "Your name": "您的姓名",
    "Your subscription has been canceled and will expire on {expiryDate}.": "您的订阅已取消，将于 {expiryDate} 到期。",
    "Your subscription will expire on {expiryDate}": "您的订阅将在{expiryDate}到期",
    "Your subscription will renew on {renewalDate}": "您的订阅将在{renewalDate}续费",
    "Your subscription will start on {subscriptionStart}": "您的订阅将于{subscriptionStart}开始"
}
